// input
export const __CMP_FIRST_NAME__ = "first-name";
export const __CMP_LAST_NAME__ = "last-name";
export const __CMP_ADDRESS__ = "address";
export const __CMP_ADDRESS_LINE1__ = "address-line1";
export const __CMP_ADDRESS_LINE2__ = "address-line2";
export const __CMP_CITY__ = "city";
export const __CMP_COMPANY__ = "company";
export const __CMP_DEALER_EMAIL__ = "dealer-email";
export const __CMP_EMAIL__ = "email";
export const __CMP_EMAIL_CAPTCHA__ = "email-captcha";
export const __CMP_INVOICE_NUMBER__ = "invoice-number";
export const __CMP_MESSAGE__ = "message";
export const __CMP_MODEL_NUMBER__ = "model-number";
export const __CMP_PHONE__ = "phone";
export const __CMP_POSTAL_CODE__ = "postal-code";
export const __CMP_PURCHASE_LOCATION__ = "purchase-location";
export const __CMP_SERIAL_NUMBER__ = "serial-number";
export const __CMP_ORDER_NUMBER__ = "order-number";
export const __CMP_OTHERS__ = "others";
export const __CMP_MIDDLE_NAME__ = "middle-name";
export const __CMP_PRODUCT_PRICE__ = "product-price";
export const __CMP_INVOICE_AMOUNT__ = "invoice-amount";
export const __CMP_DEALER_PHONE__ = "dealer-phone";
export const __CMP_PROMO_CODE__ = "promo-code";
export const __CMP_PROMOTION_REASON__ = "promotion-reason";
export const __CMP_PASSWORD__ = "password";
export const __CMP_RETYPE_PASSWORD__ = "retype-password";
export const __CMP_APARTMENT__ = "apartment";
export const __CMP_STATE__ = "state";
export const __CMP_BRAND__ = "brand";

// select
export const __CMP_CAMPAIGN__ = "campaign";
export const __CMP_CATEGORY__ = "category";
export const __CMP_STATE_PROVINCE__ = "state-province";
export const __CMP_PRODUCT_BRAND__ = "product-brand";
export const __CMP_PURCHASE_TYPE__ = "purchase-type";
export const __CMP_SUB_CATEGORY__ = "sub-category";
export const __CMP_SERVICE_TIME__ = "service-time";
export const __CMP_USAGE_TIME__ = "usage-time";
export const __CMP_PURCHASE_REASON__ = "purchase-reason";
export const __PURCHASE_LOCATION_OPTION__ = "purchase-location-option";
export const __PROMOTION_CHANNEL__ = "promotion-channel";
export const __CMP_ISSUE_TYPE__ = "issue-type";

// date
export const __CMP_PURCHASE_DATE__ = "purchase-date";
export const __CMP_DELIVERY_DATE__ = "delivery-date";
export const __CMP_RESERVATION_DATE__ = "reservation-date";
export const __CMP_INSTALLATION_DATE__ = "installation-date";
export const __CMP_BIRTHDAY__ = "birthday";

// upload
export const __CMP_INVOICE_RECEIPT__ = "invoice-receipt";
export const __CMP_WARRANTY_CARD__ = "warranty-card";

// 涉及接口的字段
export const __CMP_COUNTRY__ = "country";
export const __CMP_MANUAL_COUNTRY__ = "manual-country";
// policy
export const __CMP_PRIVACY_POLICY__ = "privacy-policy";
export const __CMP_MARKETING_OPT_IN__ = "marketing-opt-in";
export const __CMP_OPT_IN__ = "opt-in";

// action
export const __CMP_SUBMIT_BUTTON__ = "submit-button";

// product
export const __CMP_PRODUCT_LIST_V2__ = "product-list-v2";
export const __CMP_PRODUCT_LIST_V3__ = "product-list-v3";
export const __CMP_SEARCH_RESULT_V1__ = "search-result-v1";
export const __CMP_RELATED_PRODUCT_V2__ = "related-product-v2";
export const __CMP_RELATED_PRODUCT_V3__ = "related-product-v3";
export const __CMP_PRODUCT_VARIANTS_V1__ = "product-variants-v1";
export const __CMP_PRODUCT_BTNS_V1__ = "product-btns-v1";
export const __CMP_FAQ_V2__ = "mdws-faq";
export const __CMP_WISH_LIST__ = "wish-list-v1";
export const __CMP_WISH_BTN__ = "wish-btn-v1";
export const __CMP_SEARCH_RECOMMEND_LIST_V1__ = "search-recommend-list-v1";
export const __CMP_PRODUCT_SALES_V1 = "product-sales-v1";
export const __CMP_BUNDLE_V1 = "bundle-v1";
export const __CMP_NOTIFY_ME_V1 = "notify-me-v1";
export const __CMP_CART_REMINDER = "cart-reminder";
export const __CMP_DELIVERY_CHECKER_V1 = "delivery-checker-v1"
// export const __CMP_PRODUCT_BTNS_HEADLINE_V1_ = "product-btns-headline-v1";// 放在product headline里面的buttons（显示buttons里面的add to cart按钮，没有则不显示）

// shopify
export const __CMP__COMMERCE_PRODUCT_CART__ = "commerce-product-cart";
export const __CMP__COMMERCE_PRODUCT_PRICE__ = "commerce-product-price";
export const __CMP__COMMERCE_PRODUCT_CHECKOUT__ = "commerce-product-checkout";
export const __CMP__COMMERCE_PRODUCT_SHOPPING_CART__ = "commerce-product-shopping-cart";
export const __CMP__COMMERCE_LOGIN__ = "commerce-login";
export const __CMP__COMMERCE_COMPARE__ = "commerce-compare";
export const __CMP__COMMERCE_ACCOUNT__ = "commerce-account";

// export const __CMP__COMMERCE_RECOVER_PASSWORD__ = "commerce-recover-password";

// 4a-login
export const __CMP_GERMAN_4A_LOGIN__ = "german-4a-login";
export const __CMP_JUDGE_ME_V1__ = "judge-me-v1";

// toshiba 组件
// -----product------
export const __CMP_TSB_SEARCH_RESULT__ = "tsb-search-result";
export const __CMP_TOSHIBA_PRODUCT_LIST__ = "toshiba-product-list-v1";
export const __CMP_TOSHIBA_COMPARE__ = "toshiba-compare";
export const __CMP_TOSHIBA_PRODUCT_BTNS__ = "tsb-product-btns";
export const __CMP__TOSHIBA_COMMERCE_PRICE__ = "tsb-product-price";
export const __CMP_TOSHIBA_WISH_LIST__ = "toshiba-wish-list";
//
export const __CMP_TOSHIBA_RELATED_PRODUCT__ = "toshiba-related-product";
export const __CMP_TOSHIBA_SEARCH_RECOMMEND_LIST_V1__ = "toshiba-search-recommend-list-v1";
// shopify
export const __CMP_TOSHIBA_COMMERCE_ACCOUNT__ = "toshiba-commerce-account";
export const __CMP_JOB_LIST__ = "job-list";
